import * as JourneyPlannerActions from './journey-planner.actions';
import { createReducer, on } from '@ngrx/store';
import { FavoriteStop } from '../journey-planner.model';

export interface JourneyPlannerState {
    favoriteStops: FavoriteStop[];
}
export const JOURNAL_PLANNER_FEATURE_KEY = 'JournalPlanner';
export const journeyPlannerInitialState: JourneyPlannerState = {
    favoriteStops: []
};
export const journeyPlannerReducer = createReducer(
    journeyPlannerInitialState,
    on(JourneyPlannerActions.getFavoriteStopsSuccess, (state, { favoriteStops }) => ({
        ...state,
        favoriteStops
    })),
    on(JourneyPlannerActions.addFavoriteStopSuccess, (state, { favoriteStop }) => ({
        ...state,
        favoriteStops: [...state.favoriteStops, favoriteStop]
    })),
    on(JourneyPlannerActions.deleteFavoriteStopsSuccess, (state, { favoriteStops }) => ({
        ...state,
        favoriteStops: favoriteStops
    })),
    on(JourneyPlannerActions.deleteFavoriteStopSuccess, (state, { favoriteStops }) => ({
        ...state,
        favoriteStops: favoriteStops
    })),
    on(JourneyPlannerActions.refreshFavoriteStops, (state) => ({
        ...state,
        favoriteStops: [...state.favoriteStops]
    }))
);
